import { Chart } from '@repo/shared/dtos/assistant'

import { ChartComponent, SimpleChartOptions as SimpleChartOptions } from '../common/ChartComponent'
import { getEnhancedOptions } from './helpers'

export function ChartCard({
  title,
  description,
  chart,
  options,
}: {
  title: string
  description: string
  chart: Chart
  options?: SimpleChartOptions
}) {
  return (
    <div className="rounded-lg border shadow-sm border-primary-200 bg-white text-primary-950 flex flex-col p-8">
      <div className="relative z-10 h-full w-full flex flex-col gap-y-8">
        <div>
          <p className="text-lg font-semibold tracking-tight text-primary">{title}</p>
          <p className="mt-0 text-base/7 text-primary-400 text-pretty">{description}</p>
        </div>
        <div className="relative h-full">
          <ChartComponent
            chart={chart}
            options={getEnhancedOptions(
              chart,
              options ?? {
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { position: 'top' } },
              },
            )}
          />
        </div>
      </div>
    </div>
  )
}
